import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  copy(event) {
    if (event?.target?.closest?.("[data-controller~='copy-button']")) return;

    const btn = this.element.querySelector("[data-controller~='copy-button']");
    if (!btn || btn.disabled) return;

    btn.click();
  }
}
